var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col md:flex-row md:items-center md:justify-between"},[_c('h4',{staticClass:"text-white font-bold"},[_vm._v("Offers")]),_c('CreateAgencyOffer',{on:{"created":function($event){return _vm.$emit('offer-created')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }